import { render, staticRenderFns } from "./CreateOptimization.vue?vue&type=template&id=6ba03d0d&scoped=true&"
import script from "./CreateOptimization.vue?vue&type=script&lang=js&"
export * from "./CreateOptimization.vue?vue&type=script&lang=js&"
import style0 from "./CreateOptimization.vue?vue&type=style&index=0&id=6ba03d0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba03d0d",
  null
  
)

export default component.exports